// This file is auto-generated by @hey-api/openapi-ts

import { client, type Options, formDataBodySerializer } from '@hey-api/client-fetch';
import { type GetDocumentsAttachmentsDocumenttypeDocumentidData, type GetDocumentsAttachmentsDocumenttypeDocumentidError, type GetDocumentsAttachmentsDocumenttypeDocumentidResponse, type PostDocumentsAttachmentsDocumenttypeDocumentidData, type PostDocumentsAttachmentsDocumenttypeDocumentidError, type PostDocumentsAttachmentsDocumenttypeDocumentidResponse, type PostDocumentsBulkInsertDocumenttypeDocumentidData, type PostDocumentsBulkInsertDocumenttypeDocumentidError, type PostDocumentsBulkInsertDocumenttypeDocumentidResponse, type GetDocumentsDefinitionDocumentnameData, type GetDocumentsDefinitionDocumentnameError, type GetDocumentsDefinitionDocumentnameResponse, type GetDocumentsDetailsDocumenttypeDocumentidData, type GetDocumentsDetailsDocumenttypeDocumentidError, type GetDocumentsDetailsDocumenttypeDocumentidResponse, type PostDocumentsExportDocumenttypeDocumentidData, type PostDocumentsExportDocumenttypeDocumentidError, type PostDocumentsExportDocumenttypeDocumentidResponse, type GetDocumentsExportPendingHeaderidData, type GetDocumentsExportPendingHeaderidError, type GetDocumentsExportPendingHeaderidResponse, type GetDocumentsItemLookupDocumenttypeData, type GetDocumentsItemLookupDocumenttypeError, type GetDocumentsItemLookupDocumenttypeResponse, type GetDocumentsItemPriceDocumenttypeItemidData, type GetDocumentsItemPriceDocumenttypeItemidError, type GetDocumentsItemPriceDocumenttypeItemidResponse, type GetDocumentsNotesDocumenttypeDocumentidData, type GetDocumentsNotesDocumenttypeDocumentidError, type GetDocumentsNotesDocumenttypeDocumentidResponse, type PostDocumentsNotesDocumenttypeDocumentidData, type PostDocumentsNotesDocumenttypeDocumentidError, type PostDocumentsNotesDocumenttypeDocumentidResponse, type DeleteDocumentsNotesNoteidData, type DeleteDocumentsNotesNoteidError, type DeleteDocumentsNotesNoteidResponse, type GetDocumentsQueuesDocumenttypeData, type GetDocumentsQueuesDocumenttypeError, type GetDocumentsQueuesDocumenttypeResponse, type GetDocumentsSearchData, type GetDocumentsSearchError, type GetDocumentsSearchResponse, type GetDocumentsStorageKeyData, type PostDocumentsStorageKeyData, type PostDocumentsTagsDocumenttypeDocumentidData, type PostDocumentsTagsDocumenttypeDocumentidError, type PostDocumentsTagsDocumenttypeDocumentidResponse, GetDocumentsAttachmentsDocumenttypeDocumentidResponseTransformer, GetDocumentsNotesDocumenttypeDocumentidResponseTransformer, PostDocumentsNotesDocumenttypeDocumentidResponseTransformer, GetDocumentsQueuesDocumenttypeResponseTransformer, GetDocumentsSearchResponseTransformer, type PostInventoryCatalogIdUpsertData, type PostInventoryCatalogIdUpsertError, type PostInventoryCatalogIdUpsertResponse, type GetInventoryCategoriesError, type GetInventoryCategoriesResponse, type PostInventoryCategoriesData, type PostInventoryCategoriesError, type PostInventoryCategoriesResponse, type PostInventoryCategoriesIdData, type PostInventoryCategoriesIdError, type PostInventoryCategoriesIdResponse, type PostInventoryItemData, type PostInventoryItemError, type PostInventoryItemResponse, type GetInventoryItemLabelsDocumenttypeDocumentidData, type GetInventoryItemLabelsDocumenttypeDocumentidError, type GetInventoryItemLabelsDocumenttypeDocumentidResponse, type PostInventoryItemLabelsDocumenttypeDocumentidData, type PostInventoryItemLabelsDocumenttypeDocumentidError, type PostInventoryItemLabelsDocumenttypeDocumentidResponse, type GetInventoryItemLookupItemskuData, type GetInventoryItemLookupItemskuError, type GetInventoryItemLookupItemskuResponse, type GetInventoryItemTagListError, type GetInventoryItemTagListResponse, type GetInventoryItemItemskuData, type GetInventoryItemItemskuError, type GetInventoryItemItemskuResponse, type GetInventoryItemItemskuBatchesData, type GetInventoryItemItemskuBatchesError, type GetInventoryItemItemskuBatchesResponse, type PostInventoryItemItemskuContactContactcodeData, type PostInventoryItemItemskuContactContactcodeError, type PostInventoryItemItemskuContactContactcodeResponse, type PostInventoryItemItemskuIdentifierData, type PostInventoryItemItemskuIdentifierError, type PostInventoryItemItemskuIdentifierResponse, type GetInventoryItemItemskuImagesData, type GetInventoryItemItemskuImagesError, type GetInventoryItemItemskuImagesResponse, type PostInventoryItemItemskuImagesData, type PostInventoryItemItemskuImagesError, type PostInventoryItemItemskuImagesResponse, type GetInventoryItemItemskuInventoryData, type GetInventoryItemItemskuInventoryError, type GetInventoryItemItemskuInventoryResponse, type GetInventoryItemItemskuInventory3DData, type GetInventoryItemItemskuInventory3DError, type GetInventoryItemItemskuInventory3DResponse, type GetInventoryItemItemskuInventoryLogData, type GetInventoryItemItemskuInventoryLogError, type GetInventoryItemItemskuInventoryLogResponse, type GetInventoryItemItemskuInventoryDrilldownWarehouseidData, type GetInventoryItemItemskuInventoryDrilldownWarehouseidError, type GetInventoryItemItemskuInventoryDrilldownWarehouseidResponse, type GetInventoryItemItemskuPricingData, type GetInventoryItemItemskuPricingError, type GetInventoryItemItemskuPricingResponse, type GetInventoryItemItemskuQuickViewQvtypeData, type GetInventoryItemItemskuQuickViewQvtypeError, type GetInventoryItemItemskuQuickViewQvtypeResponse, type GetInventoryItemItemskuUomData, type GetInventoryItemItemskuUomError, type GetInventoryItemItemskuUomResponse, type PostInventoryItemItemskuVendorContactcodeData, type PostInventoryItemItemskuVendorContactcodeError, type PostInventoryItemItemskuVendorContactcodeResponse, type PostInventoryItemImagesData, type PostInventoryItemImagesError, type PostInventoryItemImagesResponse, type GetInventoryItemListData, type GetInventoryItemListError, type GetInventoryItemListResponse, type PatchInventoryItemTagsData, type PatchInventoryItemTagsError, type PatchInventoryItemTagsResponse, type GetInventoryPriceListIdData, type GetInventoryPriceListIdError, type GetInventoryPriceListIdResponse, type GetInventoryPriceListListError, type GetInventoryPriceListListResponse, type PostInventoryPriceListUpsertConditionalData, type PostInventoryPriceListUpsertConditionalError, type PostInventoryPriceListUpsertConditionalResponse, type PostInventoryPriceListUpsertEntriesData, type PostInventoryPriceListUpsertEntriesError, type PostInventoryPriceListUpsertEntriesResponse, type PostInventoryPriceListUpsertUomData, type PostInventoryPriceListUpsertUomError, type PostInventoryPriceListUpsertUomResponse, type PostInventoryPrintItemData, type PostInventoryPrintItemError, type PostInventoryPrintItemResponse, type PostInventoryPrintItemBulkData, type PostInventoryPrintItemBulkError, type PostInventoryPrintItemBulkResponse, type GetInventoryStockSummaryData, type GetInventoryStockSummaryError, type GetInventoryStockSummaryResponse, type GetInventoryStockSummaryDetailedData, type GetInventoryStockSummaryDetailedError, type GetInventoryStockSummaryDetailedResponse, type PostInventoryTrcData, type PostInventoryTrcError, type PostInventoryTrcResponse, type PostInventoryTrnData, type PostInventoryTrnError, type PostInventoryTrnResponse, type GetInventoryWarehousesData, type GetInventoryWarehousesError, type GetInventoryWarehousesResponse, type PostInventoryWarehousesWarehouseidBinData, type PostInventoryWarehousesWarehouseidBinError, type PostInventoryWarehousesWarehouseidBinResponse, type GetInventoryWarehousesWarehouseidBinListData, type GetInventoryWarehousesWarehouseidBinListError, type GetInventoryWarehousesWarehouseidBinListResponse, type DeleteInventoryWarehousesWarehouseidBinBinidData, type DeleteInventoryWarehousesWarehouseidBinBinidError, type DeleteInventoryWarehousesWarehouseidBinBinidResponse, type GetInventoryWarehousesWarehouseidBinsData, type GetInventoryWarehousesWarehouseidBinsError, type GetInventoryWarehousesWarehouseidBinsResponse, type PostInventoryWarehousesWarehouseidZoneData, type PostInventoryWarehousesWarehouseidZoneError, type PostInventoryWarehousesWarehouseidZoneResponse, type DeleteInventoryWarehousesWarehouseidZoneZoneidData, type DeleteInventoryWarehousesWarehouseidZoneZoneidError, type DeleteInventoryWarehousesWarehouseidZoneZoneidResponse, type GetInventoryWarehousesWarehouseidZonesData, type GetInventoryWarehousesWarehouseidZonesError, type GetInventoryWarehousesWarehouseidZonesResponse, PostInventoryItemResponseTransformer, GetInventoryItemLabelsDocumenttypeDocumentidResponseTransformer, GetInventoryItemItemskuResponseTransformer, GetInventoryItemItemskuBatchesResponseTransformer, GetInventoryItemItemskuInventory3DResponseTransformer, GetInventoryItemItemskuInventoryLogResponseTransformer, GetInventoryItemItemskuInventoryDrilldownWarehouseidResponseTransformer, GetInventoryItemItemskuPricingResponseTransformer, GetInventoryItemItemskuQuickViewQvtypeResponseTransformer, GetInventoryPriceListIdResponseTransformer, GetInventoryStockSummaryResponseTransformer, GetInventoryStockSummaryDetailedResponseTransformer, GetInventoryWarehousesWarehouseidBinsResponseTransformer, type GetMarketplacesError, type GetMarketplacesResponse, type GetMarketplacesMpidData, type GetMarketplacesMpidError, type GetMarketplacesMpidResponse, type DeleteMarketplacesMpidData, type DeleteMarketplacesMpidError, type DeleteMarketplacesMpidResponse, type PostMarketplacesMpidAmazonFbaInboundCreatePlanData, type PostMarketplacesMpidAmazonFbaInboundCreatePlanError, type PostMarketplacesMpidAmazonFbaInboundCreatePlanResponse, type PostMarketplacesMpidAmazonFbaInboundCreateShipmentData, type PostMarketplacesMpidAmazonFbaInboundCreateShipmentError, type PostMarketplacesMpidAmazonFbaInboundCreateShipmentResponse, type PostMarketplacesMpidAmazonFbaInboundPrepInstructionsData, type PostMarketplacesMpidAmazonFbaInboundPrepInstructionsError, type PostMarketplacesMpidAmazonFbaInboundPrepInstructionsResponse, type GetMarketplacesMpidListingsData, type GetMarketplacesMpidListingsError, type GetMarketplacesMpidListingsResponse, type PostMarketplacesMpidListingsData, type PostMarketplacesMpidListingsError, type PostMarketplacesMpidListingsResponse, type GetMarketplacesAmazonFbaInboundData, type GetMarketplacesAmazonFbaInboundError, type GetMarketplacesAmazonFbaInboundResponse, type GetMarketplacesAmazonFbaInboundTrnidData, type GetMarketplacesAmazonFbaInboundTrnidError, type GetMarketplacesAmazonFbaInboundTrnidResponse, type PostMarketplacesAmazonFbaInboundTrnidSubmitPackageInfoData, type PostMarketplacesAmazonFbaInboundTrnidSubmitPackageInfoError, type PostMarketplacesAmazonFbaInboundTrnidSubmitPackageInfoResponse, type DeleteMarketplacesAmazonFbaInboundTrnidTransportData, type DeleteMarketplacesAmazonFbaInboundTrnidTransportError, type DeleteMarketplacesAmazonFbaInboundTrnidTransportResponse, type PostMarketplacesAmazonFbaInboundTrnidTransportData, type PostMarketplacesAmazonFbaInboundTrnidTransportError, type PostMarketplacesAmazonFbaInboundTrnidTransportResponse, type PostMarketplacesAmazonFbaInboundTrnidTransportConfirmData, type PostMarketplacesAmazonFbaInboundTrnidTransportConfirmError, type PostMarketplacesAmazonFbaInboundTrnidTransportConfirmResponse, type PostMarketplacesAmazonFbaInboundImportData, type PostMarketplacesAmazonFbaInboundImportError, type PostMarketplacesAmazonFbaInboundImportResponse, type GetMarketplacesInventoryProfilesError, type GetMarketplacesInventoryProfilesResponse, type GetMarketplacesInventoryProfilesIdData, type GetMarketplacesInventoryProfilesIdError, type GetMarketplacesInventoryProfilesIdResponse, type GetMarketplacesLinkedServicesError, type GetMarketplacesLinkedServicesResponse, type PostMarketplacesWayfairRegisterShipmentSoidData, type PostMarketplacesWayfairRegisterShipmentSoidError, type PostMarketplacesWayfairRegisterShipmentSoidResponse, GetMarketplacesResponseTransformer, GetMarketplacesMpidResponseTransformer, GetMarketplacesAmazonFbaInboundResponseTransformer, GetMarketplacesAmazonFbaInboundTrnidResponseTransformer, type GetUserDataColumnsViewnameData, type GetUserDataColumnsViewnameError, type GetUserDataColumnsViewnameResponse, type PostUserEmailValidationRequestError, type PostUserEmailValidationRequestResponse, type GetUserNotificationsData, type GetUserNotificationsError, type GetUserNotificationsResponse, type GetUserNotificationsCountError, type GetUserNotificationsCountResponse, type GetUserOrganizationError, type GetUserOrganizationResponse, type GetUserSelfError, type GetUserSelfResponse, type PostUserSupportTicketData, type PostUserSupportTicketError, type PostUserSupportTicketResponse, type GetUserSupportTicketTicketidData, type GetUserSupportTicketTicketidError, type GetUserSupportTicketTicketidResponse, type GetUserSupportTicketListData, type GetUserSupportTicketListError, type GetUserSupportTicketListResponse, GetUserNotificationsResponseTransformer, GetUserSupportTicketTicketidResponseTransformer, GetUserSupportTicketListResponseTransformer } from './types.gen';

export class DocumentsService {
    /**
     * 🔒  [DOC04] List document attachments
     */
    public static getDocumentsAttachmentsDocumenttypeDocumentid(options: Options<GetDocumentsAttachmentsDocumenttypeDocumentidData>) {
        return (options?.client ?? client).get<GetDocumentsAttachmentsDocumenttypeDocumentidResponse, GetDocumentsAttachmentsDocumenttypeDocumentidError>({
            ...options,
            url: '/documents/attachments/{documentType}/{documentId}',
            responseTransformer: GetDocumentsAttachmentsDocumenttypeDocumentidResponseTransformer
        });
    }
    
    /**
     * 🔒  [DOC05] Create document attachment
     */
    public static postDocumentsAttachmentsDocumenttypeDocumentid(options: Options<PostDocumentsAttachmentsDocumenttypeDocumentidData>) {
        return (options?.client ?? client).post<PostDocumentsAttachmentsDocumenttypeDocumentidResponse, PostDocumentsAttachmentsDocumenttypeDocumentidError>({
            ...options,
            ...formDataBodySerializer,
            url: '/documents/attachments/{documentType}/{documentId}'
        });
    }
    
    /**
     * 🔒  [DOC22] Bulk insert
     */
    public static postDocumentsBulkInsertDocumenttypeDocumentid(options: Options<PostDocumentsBulkInsertDocumenttypeDocumentidData>) {
        return (options?.client ?? client).post<PostDocumentsBulkInsertDocumenttypeDocumentidResponse, PostDocumentsBulkInsertDocumenttypeDocumentidError>({
            ...options,
            url: '/documents/bulk-insert/{documentType}/{documentId}'
        });
    }
    
    /**
     *  [DOC10]
     */
    public static getDocumentsDefinitionDocumentname(options: Options<GetDocumentsDefinitionDocumentnameData>) {
        return (options?.client ?? client).get<GetDocumentsDefinitionDocumentnameResponse, GetDocumentsDefinitionDocumentnameError>({
            ...options,
            url: '/documents/definition/{documentName}'
        });
    }
    
    /**
     * 🔒  [DOC01] Retrieve document details
     */
    public static getDocumentsDetailsDocumenttypeDocumentid(options: Options<GetDocumentsDetailsDocumenttypeDocumentidData>) {
        return (options?.client ?? client).get<GetDocumentsDetailsDocumenttypeDocumentidResponse, GetDocumentsDetailsDocumenttypeDocumentidError>({
            ...options,
            url: '/documents/details/{documentType}/{documentId}'
        });
    }
    
    /**
     * 🔒  [DOC09] Mark document export
     */
    public static postDocumentsExportDocumenttypeDocumentid(options: Options<PostDocumentsExportDocumenttypeDocumentidData>) {
        return (options?.client ?? client).post<PostDocumentsExportDocumenttypeDocumentidResponse, PostDocumentsExportDocumenttypeDocumentidError>({
            ...options,
            url: '/documents/export/{documentType}/{documentId}'
        });
    }
    
    /**
     * 🔒  [DOC03] Retrieve list of pending export documents
     */
    public static getDocumentsExportPendingHeaderid(options: Options<GetDocumentsExportPendingHeaderidData>) {
        return (options?.client ?? client).get<GetDocumentsExportPendingHeaderidResponse, GetDocumentsExportPendingHeaderidError>({
            ...options,
            url: '/documents/export/pending/{headerId}'
        });
    }
    
    /**
     * 🔒  [DOC23] Document Item lookup
     */
    public static getDocumentsItemLookupDocumenttype(options: Options<GetDocumentsItemLookupDocumenttypeData>) {
        return (options?.client ?? client).get<GetDocumentsItemLookupDocumenttypeResponse, GetDocumentsItemLookupDocumenttypeError>({
            ...options,
            url: '/documents/item-lookup/{documentType}'
        });
    }
    
    /**
     * 🔒  [DOC24] Document Item price lookup
     */
    public static getDocumentsItemPriceDocumenttypeItemid(options: Options<GetDocumentsItemPriceDocumenttypeItemidData>) {
        return (options?.client ?? client).get<GetDocumentsItemPriceDocumenttypeItemidResponse, GetDocumentsItemPriceDocumenttypeItemidError>({
            ...options,
            url: '/documents/item-price/{documentType}/{itemId}'
        });
    }
    
    /**
     * 🔒  [DOC06] List document notes
     */
    public static getDocumentsNotesDocumenttypeDocumentid(options: Options<GetDocumentsNotesDocumenttypeDocumentidData>) {
        return (options?.client ?? client).get<GetDocumentsNotesDocumenttypeDocumentidResponse, GetDocumentsNotesDocumenttypeDocumentidError>({
            ...options,
            url: '/documents/notes/{documentType}/{documentId}',
            responseTransformer: GetDocumentsNotesDocumenttypeDocumentidResponseTransformer
        });
    }
    
    /**
     * 🔒  [DOC07] Create document note
     */
    public static postDocumentsNotesDocumenttypeDocumentid(options: Options<PostDocumentsNotesDocumenttypeDocumentidData>) {
        return (options?.client ?? client).post<PostDocumentsNotesDocumenttypeDocumentidResponse, PostDocumentsNotesDocumenttypeDocumentidError>({
            ...options,
            url: '/documents/notes/{documentType}/{documentId}',
            responseTransformer: PostDocumentsNotesDocumenttypeDocumentidResponseTransformer
        });
    }
    
    /**
     * 🔒  [DOC08] Delete document note
     */
    public static deleteDocumentsNotesNoteid(options: Options<DeleteDocumentsNotesNoteidData>) {
        return (options?.client ?? client).delete<DeleteDocumentsNotesNoteidResponse, DeleteDocumentsNotesNoteidError>({
            ...options,
            url: '/documents/notes/{noteId}'
        });
    }
    
    /**
     * 🔒  [DOC30] Document queues
     */
    public static getDocumentsQueuesDocumenttype(options: Options<GetDocumentsQueuesDocumenttypeData>) {
        return (options?.client ?? client).get<GetDocumentsQueuesDocumenttypeResponse, GetDocumentsQueuesDocumenttypeError>({
            ...options,
            url: '/documents/queues/{documentType}',
            responseTransformer: GetDocumentsQueuesDocumenttypeResponseTransformer
        });
    }
    
    /**
     * 🔒  [DOC02] Search documents
     */
    public static getDocumentsSearch(options: Options<GetDocumentsSearchData>) {
        return (options?.client ?? client).get<GetDocumentsSearchResponse, GetDocumentsSearchError>({
            ...options,
            url: '/documents/search',
            responseTransformer: GetDocumentsSearchResponseTransformer
        });
    }
    
    /**
     * 🔒  [DOC20] Retrieve storage object
     */
    public static getDocumentsStorageKey(options: Options<GetDocumentsStorageKeyData>) {
        return (options?.client ?? client).get<void>({
            ...options,
            url: '/documents/storage/{key}'
        });
    }
    
    /**
     * 🔒  [DOC21] Save storage object
     */
    public static postDocumentsStorageKey(options: Options<PostDocumentsStorageKeyData>) {
        return (options?.client ?? client).post<void>({
            ...options,
            url: '/documents/storage/{key}'
        });
    }
    
    /**
     * 🔒  [DOC31] Document tags update
     */
    public static postDocumentsTagsDocumenttypeDocumentid(options: Options<PostDocumentsTagsDocumenttypeDocumentidData>) {
        return (options?.client ?? client).post<PostDocumentsTagsDocumenttypeDocumentidResponse, PostDocumentsTagsDocumenttypeDocumentidError>({
            ...options,
            url: '/documents/tags/{documentType}/{documentId}'
        });
    }
    
}

export class InventoryService {
    /**
     * 🔒  [INV38] Catalog Items update
     */
    public static postInventoryCatalogIdUpsert(options: Options<PostInventoryCatalogIdUpsertData>) {
        return (options?.client ?? client).post<PostInventoryCatalogIdUpsertResponse, PostInventoryCatalogIdUpsertError>({
            ...options,
            url: '/inventory/catalog/{id}/upsert'
        });
    }
    
    /**
     * 🔒  [INVCT01] Item category - List
     */
    public static getInventoryCategories(options?: Options) {
        return (options?.client ?? client).get<GetInventoryCategoriesResponse, GetInventoryCategoriesError>({
            ...options,
            url: '/inventory/categories'
        });
    }
    
    /**
     * 🔒  [INVCT02] Item category - Upsert
     */
    public static postInventoryCategories(options: Options<PostInventoryCategoriesData>) {
        return (options?.client ?? client).post<PostInventoryCategoriesResponse, PostInventoryCategoriesError>({
            ...options,
            url: '/inventory/categories'
        });
    }
    
    /**
     * 🔒  [INVCT02] Item category - Upsert
     */
    public static postInventoryCategoriesId(options: Options<PostInventoryCategoriesIdData>) {
        return (options?.client ?? client).post<PostInventoryCategoriesIdResponse, PostInventoryCategoriesIdError>({
            ...options,
            url: '/inventory/categories/{id}'
        });
    }
    
    /**
     * 🔒  [INV15] List item divisions
     */
    public static getInventoryDivisions(options?: Options) {
        return (options?.client ?? client).get<void>({
            ...options,
            url: '/inventory/divisions'
        });
    }
    
    /**
     * 🔒  [INV09] Create new item
     */
    public static postInventoryItem(options?: Options<PostInventoryItemData>) {
        return (options?.client ?? client).post<PostInventoryItemResponse, PostInventoryItemError>({
            ...options,
            url: '/inventory/item',
            responseTransformer: PostInventoryItemResponseTransformer
        });
    }
    
    /**
     * 🔒  [INV42] List item labels
     */
    public static getInventoryItemLabelsDocumenttypeDocumentid(options: Options<GetInventoryItemLabelsDocumenttypeDocumentidData>) {
        return (options?.client ?? client).get<GetInventoryItemLabelsDocumenttypeDocumentidResponse, GetInventoryItemLabelsDocumenttypeDocumentidError>({
            ...options,
            url: '/inventory/item-labels/{documentType}/{documentId}',
            responseTransformer: GetInventoryItemLabelsDocumenttypeDocumentidResponseTransformer
        });
    }
    
    /**
     * 🔒  [INV43] Print item labels
     */
    public static postInventoryItemLabelsDocumenttypeDocumentid(options: Options<PostInventoryItemLabelsDocumenttypeDocumentidData>) {
        return (options?.client ?? client).post<PostInventoryItemLabelsDocumenttypeDocumentidResponse, PostInventoryItemLabelsDocumenttypeDocumentidError>({
            ...options,
            url: '/inventory/item-labels/{documentType}/{documentId}'
        });
    }
    
    /**
     * 🔒  [INV32] Get item basic info
     */
    public static getInventoryItemLookupItemsku(options: Options<GetInventoryItemLookupItemskuData>) {
        return (options?.client ?? client).get<GetInventoryItemLookupItemskuResponse, GetInventoryItemLookupItemskuError>({
            ...options,
            url: '/inventory/item-lookup/{itemSku}'
        });
    }
    
    /**
     * 🔒  [INV210] List item tag options
     */
    public static getInventoryItemTagList(options?: Options) {
        return (options?.client ?? client).get<GetInventoryItemTagListResponse, GetInventoryItemTagListError>({
            ...options,
            url: '/inventory/item-tag/list'
        });
    }
    
    /**
     * 🔒  [INV10] Get item info
     */
    public static getInventoryItemItemsku(options: Options<GetInventoryItemItemskuData>) {
        return (options?.client ?? client).get<GetInventoryItemItemskuResponse, GetInventoryItemItemskuError>({
            ...options,
            url: '/inventory/item/{itemSku}',
            responseTransformer: GetInventoryItemItemskuResponseTransformer
        });
    }
    
    /**
     * 🔒  [INV45] Item batch list
     */
    public static getInventoryItemItemskuBatches(options: Options<GetInventoryItemItemskuBatchesData>) {
        return (options?.client ?? client).get<GetInventoryItemItemskuBatchesResponse, GetInventoryItemItemskuBatchesError>({
            ...options,
            url: '/inventory/item/{itemSku}/batches',
            responseTransformer: GetInventoryItemItemskuBatchesResponseTransformer
        });
    }
    
    /**
     * 🔒  [INV41] Item contact info upsert
     */
    public static postInventoryItemItemskuContactContactcode(options: Options<PostInventoryItemItemskuContactContactcodeData>) {
        return (options?.client ?? client).post<PostInventoryItemItemskuContactContactcodeResponse, PostInventoryItemItemskuContactContactcodeError>({
            ...options,
            url: '/inventory/item/{itemSku}/contact/{contactCode}'
        });
    }
    
    /**
     * Add item identifiers
     */
    public static postInventoryItemItemskuIdentifier(options: Options<PostInventoryItemItemskuIdentifierData>) {
        return (options?.client ?? client).post<PostInventoryItemItemskuIdentifierResponse, PostInventoryItemItemskuIdentifierError>({
            ...options,
            url: '/inventory/item/{itemSku}/identifier'
        });
    }
    
    /**
     * 🔒  [INV12] Get item images
     */
    public static getInventoryItemItemskuImages(options: Options<GetInventoryItemItemskuImagesData>) {
        return (options?.client ?? client).get<GetInventoryItemItemskuImagesResponse, GetInventoryItemItemskuImagesError>({
            ...options,
            url: '/inventory/item/{itemSku}/images'
        });
    }
    
    /**
     * 🔒  [INV20] Item images - Add
     */
    public static postInventoryItemItemskuImages(options: Options<PostInventoryItemItemskuImagesData>) {
        return (options?.client ?? client).post<PostInventoryItemItemskuImagesResponse, PostInventoryItemItemskuImagesError>({
            ...options,
            url: '/inventory/item/{itemSku}/images'
        });
    }
    
    /**
     * 🔒  [INV28] item inventory summary
     */
    public static getInventoryItemItemskuInventory(options: Options<GetInventoryItemItemskuInventoryData>) {
        return (options?.client ?? client).get<GetInventoryItemItemskuInventoryResponse, GetInventoryItemItemskuInventoryError>({
            ...options,
            url: '/inventory/item/{itemSku}/inventory'
        });
    }
    
    /**
     * 🔒  [INV31] Item inventory 3rd summary
     */
    public static getInventoryItemItemskuInventory3D(options: Options<GetInventoryItemItemskuInventory3DData>) {
        return (options?.client ?? client).get<GetInventoryItemItemskuInventory3DResponse, GetInventoryItemItemskuInventory3DError>({
            ...options,
            url: '/inventory/item/{itemSku}/inventory-3d',
            responseTransformer: GetInventoryItemItemskuInventory3DResponseTransformer
        });
    }
    
    /**
     * 🔒  [INV29] Get item inventory log
     */
    public static getInventoryItemItemskuInventoryLog(options: Options<GetInventoryItemItemskuInventoryLogData>) {
        return (options?.client ?? client).get<GetInventoryItemItemskuInventoryLogResponse, GetInventoryItemItemskuInventoryLogError>({
            ...options,
            url: '/inventory/item/{itemSku}/inventory-log',
            responseTransformer: GetInventoryItemItemskuInventoryLogResponseTransformer
        });
    }
    
    /**
     * 🔒  [INV33] Get item inventory drilldown
     */
    public static getInventoryItemItemskuInventoryDrilldownWarehouseid(options: Options<GetInventoryItemItemskuInventoryDrilldownWarehouseidData>) {
        return (options?.client ?? client).get<GetInventoryItemItemskuInventoryDrilldownWarehouseidResponse, GetInventoryItemItemskuInventoryDrilldownWarehouseidError>({
            ...options,
            url: '/inventory/item/{itemSku}/inventory/drilldown/{warehouseId}',
            responseTransformer: GetInventoryItemItemskuInventoryDrilldownWarehouseidResponseTransformer
        });
    }
    
    /**
     * 🔒  [INV13] Get item pricing
     */
    public static getInventoryItemItemskuPricing(options: Options<GetInventoryItemItemskuPricingData>) {
        return (options?.client ?? client).get<GetInventoryItemItemskuPricingResponse, GetInventoryItemItemskuPricingError>({
            ...options,
            url: '/inventory/item/{itemSku}/pricing',
            responseTransformer: GetInventoryItemItemskuPricingResponseTransformer
        });
    }
    
    /**
     * 🔒  [INV34] Get item quick-view summary
     */
    public static getInventoryItemItemskuQuickViewQvtype(options: Options<GetInventoryItemItemskuQuickViewQvtypeData>) {
        return (options?.client ?? client).get<GetInventoryItemItemskuQuickViewQvtypeResponse, GetInventoryItemItemskuQuickViewQvtypeError>({
            ...options,
            url: '/inventory/item/{itemSku}/quick-view/{qvType}',
            responseTransformer: GetInventoryItemItemskuQuickViewQvtypeResponseTransformer
        });
    }
    
    /**
     * 🔒  [INV27] Get item Uom
     */
    public static getInventoryItemItemskuUom(options: Options<GetInventoryItemItemskuUomData>) {
        return (options?.client ?? client).get<GetInventoryItemItemskuUomResponse, GetInventoryItemItemskuUomError>({
            ...options,
            url: '/inventory/item/{itemSku}/uom'
        });
    }
    
    /**
     * 🔒  [INV40] Item vendor upsert
     */
    public static postInventoryItemItemskuVendorContactcode(options: Options<PostInventoryItemItemskuVendorContactcodeData>) {
        return (options?.client ?? client).post<PostInventoryItemItemskuVendorContactcodeResponse, PostInventoryItemItemskuVendorContactcodeError>({
            ...options,
            url: '/inventory/item/{itemSku}/vendor/{contactCode}'
        });
    }
    
    /**
     * 🔒  [INV21] Item images - Upload
     * Only supports multipart/form-data
     */
    public static postInventoryItemImages(options?: Options<PostInventoryItemImagesData>) {
        return (options?.client ?? client).post<PostInventoryItemImagesResponse, PostInventoryItemImagesError>({
            ...options,
            ...formDataBodySerializer,
            url: '/inventory/item/images'
        });
    }
    
    /**
     * 🔒  [INV82] List items
     */
    public static getInventoryItemList(options?: Options<GetInventoryItemListData>) {
        return (options?.client ?? client).get<GetInventoryItemListResponse, GetInventoryItemListError>({
            ...options,
            url: '/inventory/item/list'
        });
    }
    
    /**
     * 🔒  [INV11] Item tags
     */
    public static patchInventoryItemTags(options?: Options<PatchInventoryItemTagsData>) {
        return (options?.client ?? client).patch<PatchInventoryItemTagsResponse, PatchInventoryItemTagsError>({
            ...options,
            url: '/inventory/item/tags'
        });
    }
    
    /**
     * 🔒  [INV18] Get price-list items
     */
    public static getInventoryPriceListId(options: Options<GetInventoryPriceListIdData>) {
        return (options?.client ?? client).get<GetInventoryPriceListIdResponse, GetInventoryPriceListIdError>({
            ...options,
            url: '/inventory/price-list/{id}',
            responseTransformer: GetInventoryPriceListIdResponseTransformer
        });
    }
    
    /**
     * 🔒  [INV17] List price-lists
     */
    public static getInventoryPriceListList(options?: Options) {
        return (options?.client ?? client).get<GetInventoryPriceListListResponse, GetInventoryPriceListListError>({
            ...options,
            url: '/inventory/price-list/list'
        });
    }
    
    /**
     * 🔒  [INV35] Pricelist Conditionals Upsert
     */
    public static postInventoryPriceListUpsertConditional(options?: Options<PostInventoryPriceListUpsertConditionalData>) {
        return (options?.client ?? client).post<PostInventoryPriceListUpsertConditionalResponse, PostInventoryPriceListUpsertConditionalError>({
            ...options,
            url: '/inventory/price-list/upsert/conditional'
        });
    }
    
    /**
     * 🔒  [INV37] Pricelist Upsert
     */
    public static postInventoryPriceListUpsertEntries(options?: Options<PostInventoryPriceListUpsertEntriesData>) {
        return (options?.client ?? client).post<PostInventoryPriceListUpsertEntriesResponse, PostInventoryPriceListUpsertEntriesError>({
            ...options,
            url: '/inventory/price-list/upsert/entries'
        });
    }
    
    /**
     * 🔒  [INV36] Pricelist Uom Upsert
     */
    public static postInventoryPriceListUpsertUom(options?: Options<PostInventoryPriceListUpsertUomData>) {
        return (options?.client ?? client).post<PostInventoryPriceListUpsertUomResponse, PostInventoryPriceListUpsertUomError>({
            ...options,
            url: '/inventory/price-list/upsert/uom'
        });
    }
    
    /**
     *  [INV14] Send item label to queue
     */
    public static postInventoryPrintItem(options?: Options<PostInventoryPrintItemData>) {
        return (options?.client ?? client).post<PostInventoryPrintItemResponse, PostInventoryPrintItemError>({
            ...options,
            url: '/inventory/print-item'
        });
    }
    
    /**
     *  [INV25] Send item label to queue (Bulk)
     */
    public static postInventoryPrintItemBulk(options?: Options<PostInventoryPrintItemBulkData>) {
        return (options?.client ?? client).post<PostInventoryPrintItemBulkResponse, PostInventoryPrintItemBulkError>({
            ...options,
            url: '/inventory/print-item-bulk'
        });
    }
    
    /**
     *  [INV22] List stock summary of items
     */
    public static getInventoryStockSummary(options?: Options<GetInventoryStockSummaryData>) {
        return (options?.client ?? client).get<GetInventoryStockSummaryResponse, GetInventoryStockSummaryError>({
            ...options,
            url: '/inventory/stock-summary',
            responseTransformer: GetInventoryStockSummaryResponseTransformer
        });
    }
    
    /**
     *  [INV23] List detailed stock summary of items
     * Get a stock summary of items, split by batch and bin location,  Results will not include un-batched and un-binned items. Results will not include zero quantity
     */
    public static getInventoryStockSummaryDetailed(options?: Options<GetInventoryStockSummaryDetailedData>) {
        return (options?.client ?? client).get<GetInventoryStockSummaryDetailedResponse, GetInventoryStockSummaryDetailedError>({
            ...options,
            url: '/inventory/stock-summary-detailed',
            responseTransformer: GetInventoryStockSummaryDetailedResponseTransformer
        });
    }
    
    /**
     *  [INV26] Create a stock transaction
     */
    public static postInventoryTrc(options?: Options<PostInventoryTrcData>) {
        return (options?.client ?? client).post<PostInventoryTrcResponse, PostInventoryTrcError>({
            ...options,
            url: '/inventory/trc'
        });
    }
    
    /**
     *  [INV24] Create a stock transfer
     */
    public static postInventoryTrn(options?: Options<PostInventoryTrnData>) {
        return (options?.client ?? client).post<PostInventoryTrnResponse, PostInventoryTrnError>({
            ...options,
            url: '/inventory/trn'
        });
    }
    
    /**
     * 🔒  [INVW01] Warehouses
     */
    public static getInventoryWarehouses(options?: Options<GetInventoryWarehousesData>) {
        return (options?.client ?? client).get<GetInventoryWarehousesResponse, GetInventoryWarehousesError>({
            ...options,
            url: '/inventory/warehouses'
        });
    }
    
    /**
     * 🔒  [INVW07] Warehouse bin upsert
     */
    public static postInventoryWarehousesWarehouseidBin(options: Options<PostInventoryWarehousesWarehouseidBinData>) {
        return (options?.client ?? client).post<PostInventoryWarehousesWarehouseidBinResponse, PostInventoryWarehousesWarehouseidBinError>({
            ...options,
            url: '/inventory/warehouses/{warehouseId}/bin'
        });
    }
    
    /**
     * 🔒  [INVW03] Warehouse bin list
     */
    public static getInventoryWarehousesWarehouseidBinList(options: Options<GetInventoryWarehousesWarehouseidBinListData>) {
        return (options?.client ?? client).get<GetInventoryWarehousesWarehouseidBinListResponse, GetInventoryWarehousesWarehouseidBinListError>({
            ...options,
            url: '/inventory/warehouses/{warehouseId}/bin-list'
        });
    }
    
    /**
     * 🔒  [INVW08] Warehouse bin delete
     */
    public static deleteInventoryWarehousesWarehouseidBinBinid(options: Options<DeleteInventoryWarehousesWarehouseidBinBinidData>) {
        return (options?.client ?? client).delete<DeleteInventoryWarehousesWarehouseidBinBinidResponse, DeleteInventoryWarehousesWarehouseidBinBinidError>({
            ...options,
            url: '/inventory/warehouses/{warehouseId}/bin/{binId}'
        });
    }
    
    /**
     * 🔒  [INVW02] Warehouse bins
     */
    public static getInventoryWarehousesWarehouseidBins(options: Options<GetInventoryWarehousesWarehouseidBinsData>) {
        return (options?.client ?? client).get<GetInventoryWarehousesWarehouseidBinsResponse, GetInventoryWarehousesWarehouseidBinsError>({
            ...options,
            url: '/inventory/warehouses/{warehouseId}/bins',
            responseTransformer: GetInventoryWarehousesWarehouseidBinsResponseTransformer
        });
    }
    
    /**
     * 🔒  [INVW05] Warehouse zone upsert
     */
    public static postInventoryWarehousesWarehouseidZone(options: Options<PostInventoryWarehousesWarehouseidZoneData>) {
        return (options?.client ?? client).post<PostInventoryWarehousesWarehouseidZoneResponse, PostInventoryWarehousesWarehouseidZoneError>({
            ...options,
            url: '/inventory/warehouses/{warehouseId}/zone'
        });
    }
    
    /**
     * 🔒  [INVW06] Warehouse zone delete
     */
    public static deleteInventoryWarehousesWarehouseidZoneZoneid(options: Options<DeleteInventoryWarehousesWarehouseidZoneZoneidData>) {
        return (options?.client ?? client).delete<DeleteInventoryWarehousesWarehouseidZoneZoneidResponse, DeleteInventoryWarehousesWarehouseidZoneZoneidError>({
            ...options,
            url: '/inventory/warehouses/{warehouseId}/zone/{zoneId}'
        });
    }
    
    /**
     * 🔒  [INVW04] Warehouse zones
     */
    public static getInventoryWarehousesWarehouseidZones(options: Options<GetInventoryWarehousesWarehouseidZonesData>) {
        return (options?.client ?? client).get<GetInventoryWarehousesWarehouseidZonesResponse, GetInventoryWarehousesWarehouseidZonesError>({
            ...options,
            url: '/inventory/warehouses/{warehouseId}/zones'
        });
    }
    
}

export class MarketplacesService {
    /**
     * 🔒  [MRT07] Marketplaces
     */
    public static getMarketplaces(options?: Options) {
        return (options?.client ?? client).get<GetMarketplacesResponse, GetMarketplacesError>({
            ...options,
            url: '/marketplaces',
            responseTransformer: GetMarketplacesResponseTransformer
        });
    }
    
    /**
     * 🔒  [MRT02] Marketplace details
     */
    public static getMarketplacesMpid(options: Options<GetMarketplacesMpidData>) {
        return (options?.client ?? client).get<GetMarketplacesMpidResponse, GetMarketplacesMpidError>({
            ...options,
            url: '/marketplaces/{mpId}',
            responseTransformer: GetMarketplacesMpidResponseTransformer
        });
    }
    
    /**
     * 🔒  [MRT08] Delete marketplace
     */
    public static deleteMarketplacesMpid(options: Options<DeleteMarketplacesMpidData>) {
        return (options?.client ?? client).delete<DeleteMarketplacesMpidResponse, DeleteMarketplacesMpidError>({
            ...options,
            url: '/marketplaces/{mpId}'
        });
    }
    
    /**
     * 🔒  [MRT05] Amazon: FBA Inbound - Create plan
     */
    public static postMarketplacesMpidAmazonFbaInboundCreatePlan(options: Options<PostMarketplacesMpidAmazonFbaInboundCreatePlanData>) {
        return (options?.client ?? client).post<PostMarketplacesMpidAmazonFbaInboundCreatePlanResponse, PostMarketplacesMpidAmazonFbaInboundCreatePlanError>({
            ...options,
            url: '/marketplaces/{mpId}/amazon/fba-inbound/create-plan'
        });
    }
    
    /**
     * 🔒  [MRT06] Amazon: FBA Inbound - Create Shipment
     */
    public static postMarketplacesMpidAmazonFbaInboundCreateShipment(options: Options<PostMarketplacesMpidAmazonFbaInboundCreateShipmentData>) {
        return (options?.client ?? client).post<PostMarketplacesMpidAmazonFbaInboundCreateShipmentResponse, PostMarketplacesMpidAmazonFbaInboundCreateShipmentError>({
            ...options,
            url: '/marketplaces/{mpId}/amazon/fba-inbound/create-shipment'
        });
    }
    
    /**
     * 🔒  [MRT04] Amazon: FBA Inbound - Prep Instructions
     */
    public static postMarketplacesMpidAmazonFbaInboundPrepInstructions(options: Options<PostMarketplacesMpidAmazonFbaInboundPrepInstructionsData>) {
        return (options?.client ?? client).post<PostMarketplacesMpidAmazonFbaInboundPrepInstructionsResponse, PostMarketplacesMpidAmazonFbaInboundPrepInstructionsError>({
            ...options,
            url: '/marketplaces/{mpId}/amazon/fba-inbound/prep-instructions'
        });
    }
    
    /**
     * 🔒  [MRT01] Marketplace listings
     */
    public static getMarketplacesMpidListings(options: Options<GetMarketplacesMpidListingsData>) {
        return (options?.client ?? client).get<GetMarketplacesMpidListingsResponse, GetMarketplacesMpidListingsError>({
            ...options,
            url: '/marketplaces/{mpId}/listings'
        });
    }
    
    /**
     * 🔒  [MRT10] Marketplace listings bulk
     */
    public static postMarketplacesMpidListings(options: Options<PostMarketplacesMpidListingsData>) {
        return (options?.client ?? client).post<PostMarketplacesMpidListingsResponse, PostMarketplacesMpidListingsError>({
            ...options,
            url: '/marketplaces/{mpId}/listings'
        });
    }
    
    /**
     * 🔒 Amazon: FBA Inbound - List TRN
     */
    public static getMarketplacesAmazonFbaInbound(options?: Options<GetMarketplacesAmazonFbaInboundData>) {
        return (options?.client ?? client).get<GetMarketplacesAmazonFbaInboundResponse, GetMarketplacesAmazonFbaInboundError>({
            ...options,
            url: '/marketplaces/amazon/fba-inbound',
            responseTransformer: GetMarketplacesAmazonFbaInboundResponseTransformer
        });
    }
    
    /**
     * 🔒 Amazon: FBA Inbound - TRN Info
     */
    public static getMarketplacesAmazonFbaInboundTrnid(options: Options<GetMarketplacesAmazonFbaInboundTrnidData>) {
        return (options?.client ?? client).get<GetMarketplacesAmazonFbaInboundTrnidResponse, GetMarketplacesAmazonFbaInboundTrnidError>({
            ...options,
            url: '/marketplaces/amazon/fba-inbound/{trnId}',
            responseTransformer: GetMarketplacesAmazonFbaInboundTrnidResponseTransformer
        });
    }
    
    /**
     * 🔒 Amazon: FBA Inbound - Transport 0 Submit package info
     */
    public static postMarketplacesAmazonFbaInboundTrnidSubmitPackageInfo(options: Options<PostMarketplacesAmazonFbaInboundTrnidSubmitPackageInfoData>) {
        return (options?.client ?? client).post<PostMarketplacesAmazonFbaInboundTrnidSubmitPackageInfoResponse, PostMarketplacesAmazonFbaInboundTrnidSubmitPackageInfoError>({
            ...options,
            url: '/marketplaces/amazon/fba-inbound/{trnId}/submit-package-info'
        });
    }
    
    /**
     * 🔒 Amazon: FBA Inbound - Transport 3 Void
     */
    public static deleteMarketplacesAmazonFbaInboundTrnidTransport(options: Options<DeleteMarketplacesAmazonFbaInboundTrnidTransportData>) {
        return (options?.client ?? client).delete<DeleteMarketplacesAmazonFbaInboundTrnidTransportResponse, DeleteMarketplacesAmazonFbaInboundTrnidTransportError>({
            ...options,
            url: '/marketplaces/amazon/fba-inbound/{trnId}/transport'
        });
    }
    
    /**
     * 🔒 Amazon: FBA Inbound - Transport 1 Request
     */
    public static postMarketplacesAmazonFbaInboundTrnidTransport(options: Options<PostMarketplacesAmazonFbaInboundTrnidTransportData>) {
        return (options?.client ?? client).post<PostMarketplacesAmazonFbaInboundTrnidTransportResponse, PostMarketplacesAmazonFbaInboundTrnidTransportError>({
            ...options,
            url: '/marketplaces/amazon/fba-inbound/{trnId}/transport'
        });
    }
    
    /**
     * 🔒 Amazon: FBA Inbound - Transport 2 Confirm
     */
    public static postMarketplacesAmazonFbaInboundTrnidTransportConfirm(options: Options<PostMarketplacesAmazonFbaInboundTrnidTransportConfirmData>) {
        return (options?.client ?? client).post<PostMarketplacesAmazonFbaInboundTrnidTransportConfirmResponse, PostMarketplacesAmazonFbaInboundTrnidTransportConfirmError>({
            ...options,
            url: '/marketplaces/amazon/fba-inbound/{trnId}/transport-confirm'
        });
    }
    
    /**
     * 🔒 Amazon: FBA Inbound - Paste Import
     */
    public static postMarketplacesAmazonFbaInboundImport(options?: Options<PostMarketplacesAmazonFbaInboundImportData>) {
        return (options?.client ?? client).post<PostMarketplacesAmazonFbaInboundImportResponse, PostMarketplacesAmazonFbaInboundImportError>({
            ...options,
            url: '/marketplaces/amazon/fba-inbound/import'
        });
    }
    
    /**
     * 🔒 Inventory Profiles
     */
    public static getMarketplacesInventoryProfiles(options?: Options) {
        return (options?.client ?? client).get<GetMarketplacesInventoryProfilesResponse, GetMarketplacesInventoryProfilesError>({
            ...options,
            url: '/marketplaces/inventory-profiles'
        });
    }
    
    /**
     * 🔒 Inventory Profile details
     */
    public static getMarketplacesInventoryProfilesId(options: Options<GetMarketplacesInventoryProfilesIdData>) {
        return (options?.client ?? client).get<GetMarketplacesInventoryProfilesIdResponse, GetMarketplacesInventoryProfilesIdError>({
            ...options,
            url: '/marketplaces/inventory-profiles/{id}'
        });
    }
    
    /**
     * 🔒 Linked services
     */
    public static getMarketplacesLinkedServices(options?: Options) {
        return (options?.client ?? client).get<GetMarketplacesLinkedServicesResponse, GetMarketplacesLinkedServicesError>({
            ...options,
            url: '/marketplaces/linked-services'
        });
    }
    
    /**
     * 🔒  [MRT03] Wayfair: Register Shipment
     */
    public static postMarketplacesWayfairRegisterShipmentSoid(options: Options<PostMarketplacesWayfairRegisterShipmentSoidData>) {
        return (options?.client ?? client).post<PostMarketplacesWayfairRegisterShipmentSoidResponse, PostMarketplacesWayfairRegisterShipmentSoidError>({
            ...options,
            url: '/marketplaces/wayfair/register-shipment/{soId}'
        });
    }
    
}

export class UserService {
    /**
     * 🔒  [USR09] Columns display settings
     */
    public static getUserDataColumnsViewname(options: Options<GetUserDataColumnsViewnameData>) {
        return (options?.client ?? client).get<GetUserDataColumnsViewnameResponse, GetUserDataColumnsViewnameError>({
            ...options,
            url: '/user/data-columns/{viewName}'
        });
    }
    
    /**
     * 🔒  [USR23] Request email validation
     */
    public static postUserEmailValidationRequest(options?: Options) {
        return (options?.client ?? client).post<PostUserEmailValidationRequestResponse, PostUserEmailValidationRequestError>({
            ...options,
            url: '/user/email-validation-request'
        });
    }
    
    /**
     * 🔒  [USR26] User notifications
     */
    public static getUserNotifications(options?: Options<GetUserNotificationsData>) {
        return (options?.client ?? client).get<GetUserNotificationsResponse, GetUserNotificationsError>({
            ...options,
            url: '/user/notifications',
            responseTransformer: GetUserNotificationsResponseTransformer
        });
    }
    
    /**
     * 🔒  [USR25] User notifications count
     */
    public static getUserNotificationsCount(options?: Options) {
        return (options?.client ?? client).get<GetUserNotificationsCountResponse, GetUserNotificationsCountError>({
            ...options,
            url: '/user/notifications-count'
        });
    }
    
    /**
     *  [USR10] Organization information
     */
    public static getUserOrganization(options?: Options) {
        return (options?.client ?? client).get<GetUserOrganizationResponse, GetUserOrganizationError>({
            ...options,
            url: '/user/organization'
        });
    }
    
    /**
     *  [USR08] User information
     */
    public static getUserSelf(options?: Options) {
        return (options?.client ?? client).get<GetUserSelfResponse, GetUserSelfError>({
            ...options,
            url: '/user/self'
        });
    }
    
    /**
     * 🔒  [US24] Support ticket
     */
    public static postUserSupportTicket(options?: Options<PostUserSupportTicketData>) {
        return (options?.client ?? client).post<PostUserSupportTicketResponse, PostUserSupportTicketError>({
            ...options,
            ...formDataBodySerializer,
            url: '/user/support-ticket'
        });
    }
    
    /**
     * 🔒  [USR22] Get user support ticket
     */
    public static getUserSupportTicketTicketid(options: Options<GetUserSupportTicketTicketidData>) {
        return (options?.client ?? client).get<GetUserSupportTicketTicketidResponse, GetUserSupportTicketTicketidError>({
            ...options,
            url: '/user/support-ticket/{ticketId}',
            responseTransformer: GetUserSupportTicketTicketidResponseTransformer
        });
    }
    
    /**
     * 🔒  [USR21] List support tickets
     */
    public static getUserSupportTicketList(options?: Options<GetUserSupportTicketListData>) {
        return (options?.client ?? client).get<GetUserSupportTicketListResponse, GetUserSupportTicketListError>({
            ...options,
            url: '/user/support-ticket/list',
            responseTransformer: GetUserSupportTicketListResponseTransformer
        });
    }
    
}